// extracted by mini-css-extract-plugin
module.exports = {"guardDisplay":"styles_guardDisplay__ioxXI","warning":"styles_warning__Iw9Jm","info":"styles_info__jVCYK"};